import { render, staticRenderFns } from "./ObjectionCreate.vue?vue&type=template&id=a0f2c996&scoped=true"
import script from "./ObjectionCreate.vue?vue&type=script&lang=ts"
export * from "./ObjectionCreate.vue?vue&type=script&lang=ts"
import style0 from "./ObjectionCreate.vue?vue&type=style&index=0&id=a0f2c996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f2c996",
  null
  
)

export default component.exports